import { type ResourceId } from '@app/client';
import { type NftMintSteps } from '@app/client/common/structs/nft/nft';

export const ACTION_SET_LIQUID_ID_COLLECTION_ID = 'ACTION_SET_LIQUID_ID_COLLECTION_ID';
export const ACTION_NFT_MINT_PANEL_STEP = 'ACTION_NFT_MINT_PANEL_STEP';
export const ACTION_SET_NFT_PANEL_OPEN = 'ACTION_SET_NFT_PANEL_OPEN';
export const ACTION_SET_OPENSEA_URL = 'ACTION_SET_OPENSEA_URL';
export const ACTION_RESET_NFT_STORE = 'ACTION_RESET_NFT_STORE';

export interface NftState {
    liquidIdCollectionId: ResourceId | null;
    nftPanelOpen: boolean;
    nftMintPanelStep: NftMintSteps | null;
    // TODO: Deprecate this once token id is coming from API.
    openSeaUrl: string | null;
}

interface setNftPanelOpen {
    type: typeof ACTION_SET_NFT_PANEL_OPEN;
    nftPanelOpen: boolean;
}

interface setNftMintPanelStep {
    type: typeof ACTION_NFT_MINT_PANEL_STEP;
    nftMintPanelStep: NftMintSteps | null;
}

interface setOpenSeaUrl {
    type: typeof ACTION_SET_OPENSEA_URL;
    openSeaUrl: string | null;
}

interface SetLiquidIdCollectionId {
    type: typeof ACTION_SET_LIQUID_ID_COLLECTION_ID;
    liquidIdCollectionId: ResourceId;
}

interface ResetNftStoreAction {
    type: typeof ACTION_RESET_NFT_STORE;
}

export type NftActionTypes =
    | setNftPanelOpen
    | setNftMintPanelStep
    | setOpenSeaUrl
    | SetLiquidIdCollectionId
    | ResetNftStoreAction;
